<section class="subscribe-section pt-15 pb-15 img-bg py-3">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-xl-6 col-lg-6">
                <ul class="list-tab" #tablist>
                    <li> <a class="active" href="https://www.sacombank.com.vn/canhan/Pages/default.aspx">Cá nhân</a></li>
                    <li> <a href="https://www.sacombank.com.vn/doanhnghiep/Pages/default.aspx">Doanh nghiệp</a> </li>
                    <li> <a href="https://www.sacombank.com.vn/Pages/default.aspx">Về SACOMBANK</a> </li>
                </ul>
            </div>
            <div class="col-xl-6 col-lg-6">
                <ul class="list-text">
                    <li>Download app</li>
                    <li><img src="assets/img/android_app.png" alt="" /></li>
                    <li><img src="assets/img/apple_app.png" alt="" /></li>
                </ul>
            </div>
        </div>
    </div>
</section>
<!-- ========================= subscribe-section end ========================= -->
<footer class="footer pt-0" *ngIf="!isMobile">
    <div class="container">
        <div class="copyright-area">
            <div class="row align-items-center">
                <div class="col-md-6">
                    <div class="footer-social-links">
                        <ul class="d-flex mb-0">
                            <li>
                                <a href="javascript:;"><i class="fa fa-facebook"></i></a>
                            </li>
                            <li>
                                <a href="javascript:;"><i class="fa fa-google-plus"></i></a>
                            </li>
                            <li>
                                <a href="javascript:;"><i class="fa fa-dribbble"></i></a>
                            </li>
                            <li>
                                <a href="javascript:;"><i class="fa fa-linkedin"></i></a>
                            </li>
                            <li>
                                <a href="javascript:;"><i class="fa fa-twitter"></i></a>
                            </li>
                            <li>
                                <a href="javascript:;"><i class="fa fa-skype"></i></a>
                            </li>
                            <li>
                                <a href="javascript:;"><i class="fa fa-github"></i></a>
                            </li>
                            <li>
                                <a href="javascript:;"><i class="fa fa-youtube"></i></a>
                            </li>
                            <li>
                                <a href="javascript:;"><i class="fa fa-dropbox"></i></a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="col-md-6">
                    <p class="copyright-text wow fadeInUp mb-0" data-wow-delay=".3s">©
                        <a href="https://www.sacombank.com.vn/" rel="nofollow">SACOMBANK</a> 2016 All rights reserved.
                    </p>
                </div>
            </div>
        </div>
    </div>
</footer>